import init from './init';
import config, { EcoType } from './config';
import Api from './api';
import setTitle from './setTitle/index';
import { ecoType } from './const';
var Eco = {
  init: init,
  EcoType: EcoType,
  config: config,
  Api: Api,
  setTitle: setTitle,
  ecoType: ecoType
};
export default Eco;